import Config from "src/Constants/Config";

import setCurrentPage from "src/Utils/setCurrentPage";

import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import { Audios, Animation } from "@yamildiego/presentation-kit";

const PageId = 206;
const PreviousPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA_JOURNEY_ONE = () => {
  const path = "/images/balance_rollover/phone_06/phone_";
  const DATA_IMAGES = [
    { image: `${Config.BASE_URL}${path}0.png`, effect: "animate-phone", imageStyle: { width: "72.375rem", right: 0, top: 0 } },
    { image: `${Config.BASE_URL}${path}1.png`, imageStyle: { right: 0, top: 0, width: "72.375rem" } },
    { image: `${Config.BASE_URL}${path}2.png`, imageStyle: { right: 0, top: 0, width: "72.375rem" } },
    { image: `${Config.BASE_URL}${path}3.png`, imageStyle: { right: 0, top: 0, width: "72.375rem" } },
  ];

  const times = [6800, 1000, 4000, 5000];

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const muted = useSelector(() => store.getState().appReducer.muted);
  const audioSrc = `${Config.BASE_URL}/audios/balance_rollover/PRCX_18_Balance - ${PageId}.mp3`;

  return {
    bgImage: `${Config.BASE_URL}/images/balance_rollover/bg_03.png`,
    labels: [
      {
        icon: `${Config.BASE_URL}/images/icons/clock.png`,
        text: "4:10 PM",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/location.png`,
        text: "Office",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/oration.png`,
        text: "Oration",
        style: { backgroundColor: "#c3834e" },
      },
    ],
    text: "After receiving James' details,\nOration retrieves his super fund\nbalance and advises him to\ndownload the app for easy access.",
    back: { label: "Go Back", type: "back", startIcon: "arrow-left", onClick: () => setCurrentPage(PreviousPageId) },
    next: { label: "Continue", type: "next", endIcon: "arrow-right", onClick: () => setCurrentPage(NextPageId) },
    rightSideComponent: <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,
    audio: <Audios muted={muted} pageNumber={PageId} currentPage={currentPage} audios={[{ src: audioSrc, timer: 0 }]} />,
  };
};

export default DATA_JOURNEY_ONE;
